import { createColumnHelper } from "@tanstack/react-table";
import editIcon from '../../../assets/images/editIcon.svg'
import eyeIcon from '../../../assets/images/eye.svg'
import pendingIcon from '../../../assets/images/pendingsymbol.svg'
import xIcon from '../../../assets/images/xmark.svg'
import downloadIcon from '../../../assets/images/download.svg'
import questionMarkIcon from '../../../assets/images/question-mark.svg'
import placeShipmentIcon from '../../../assets/images/ship.svg'
import deleteIcon from '../../../assets/images/trash.svg'
import receiveIcon from '../../../assets/images/tick.svg'
import ReasonModalComponent from "../../../components/Modals/ReasonModalComponent";
import RejectReasonShipmentModalComponent from "../../../components/Modals/RejectReasonShipmentModalComponent";
import AcceptShipmentModalComponent from "../../../components/Modals/AcceptShipmentModalComponent";
import { getDate } from "../../../helpers/helperFunction.js"
// import'


const columnHelper = createColumnHelper();

const ColumnDefShipmentInbox = (navigateCallback, actionHandler, isReasonModalOpen) => [
  {
    accessorKey: 'invoiceNumber',
    header: 'Supplier Invoice Number'

  },
  columnHelper.accessor(row => {
    // console.log("Test row", row);
    return row.buyerCompany ? row.buyerCompany.companyName : "N/A";
  }, {
    id: 'buyerCompany', // Custom ID for the column
    header: 'Buyer',
  }),
  columnHelper.accessor(row => {
    return row.sellerCompany ? row.sellerCompany.companyName : "N/A";
  }, {
    id: 'sellerCompany', // Custom ID for the column
    header: 'Supplier',
  }),
  columnHelper.accessor(row => {
    return row.invoiceDate ? getDate(row.invoiceDate) : "";
  }, {
    id: 'invoiceDate', // Custom ID for the column
    header: 'Invoice Date',
  }),
  columnHelper.accessor(row => {
    return row.shipmentDate ? getDate(row.shipmentDate) : "";
  }, {
    id: 'shipmentDate',
    header: 'Shipment Date',
  }),
  columnHelper.accessor(row => {
    return row.receivedDate ? getDate(row.receivedDate) : "";
  }, {
    id: 'receivedDate',
    header: 'Received Date',
  }),
  {
    accessorKey: 'status',
    header: 'Shipment Status',
    enableColumnFilter: false,
    cell: ({ row }) => {
      let statusClass = '';
      switch (row.original.status) {
        case 'Received':
          statusClass = 'bg-placed';
          break;
        case 'Shipped':
          statusClass = 'bg-shipped';
          break;
        case 'Rejected':
          statusClass = 'bg-reject';
          break;
        case 'Cancelled':
          statusClass = 'bg-reject';
          break;
        // Add more cases as needed for other status values
        default:
          statusClass = '';
      }

      return <span className={`badge ${statusClass}`}>{row.original.status}</span>;
    }
  },
  {
    accessorKey: 'linkedPo',
    header: 'Linked PO #',
    // cell: ({ row }) => (
    //   // <button onClick={() => navigateCallback(row.original.id)}>
    //   //     Go to Details
    //   // </button>
    //   <div class="d-flex clays-sm">
    //     <button class="icon-clay">
    //       {/* <span class="inner-clay color-green"><i class="bi bi-pencil-square"><img src={pendingIcon} alt="pending"/></i></span> */}
    //       <span class="inner-clay color-green"><img src={pendingIcon} alt="pending" /></span>
    //     </button>

    //   </div>
    // )
  },
  {
    accessorKey: 'action',
    header: 'Action',
    cell: ({ row }) => (
      // <button onClick={() => navigateCallback(row.original.orderId)}>
      //     Go to Details
      // </button>
      <div class="d-flex clays-sm">
        <button class="icon-clay" onClick={() => {
          // console.log("row in row", row)
          navigateCallback(row.original.shipmentId)
        }}>
          {/* <span class="inner-clay color-black"><i class="bi bi-eye"><img src={eyeIcon} alt="View"/></i></span> */}
          <span class="inner-clay color-black"><img src={eyeIcon} alt="View" /></span>
        </button>
        {row.original.isReceived === 1 && (
          <button class="icon-clay" onClick={() => actionHandler(row.original.shipmentId, 'download')}>
            <span class="inner-clay color-black"><img src={downloadIcon} alt="Download" /></span>
          </button>
        )}
        {row.original.isReceived === 0 && row.original.isRejected === 0 && row.original.isCancelled === 0 && (
          //    <>
          //    <AcceptShipmentModalComponent
          //      // open={isReasonModalOpen}
          //      // onClose={() => onClose}
          //      // action={actionType}
          //      shipmentId={row.original.shipmentId} />
          //  </>
          <button class="icon-clay" onClick={() => actionHandler(row.original.shipmentId, 'receive', row.original)}>
            <span class="inner-clay color-green"><img src={receiveIcon} alt="View" /></span>
          </button>
        )}
        {row.original.isReceived === 0 && row.original.isRejected === 0 && row.original.isCancelled === 0 && (
          <button class="icon-clay" onClick={() => actionHandler(row.original.shipmentId, 'rejectShipment')}>
            {/* <span class="inner-clay color-red"><i class="bi bi-x-lg"><img src={xIcon} alt="Delete"/></i></span> */}
            <span class="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
          </button>
        )}
        {row.original.isCancelled === 1 && (
          <>
            <ReasonModalComponent
              // open={isReasonModalOpen}
              // onClose={() => onClose}
              // action={actionType}
              reasonData={row.original} />
          </>
        )}
        {row.original.isRejected === 1 && (
          <>
            <RejectReasonShipmentModalComponent
              // open={isReasonModalOpen}
              // onClose={() => onClose}
              // action={actionType}
              rejectReasonData={row.original} />
          </>
        )}
      </div>
    )
  },
];
const ColumnDefShipmentOutbox = (handleAction, isReasonModalOpen) => [
  {
    accessorKey: 'invoiceNumber',
    header: 'Supplier Invoice Number'

  },
  columnHelper.accessor(row => {
    // console.log("Test row", row);
    return row.buyerCompany ? row.buyerCompany.companyName : "N/A";
  }, {
    id: 'buyerCompany', // Custom ID for the column
    header: 'Buyer',
  }),
  columnHelper.accessor(row => {
    return row.invoiceDate ? getDate(row.invoiceDate) : "";
  }, {
    id: 'invoiceDate', // Custom ID for the column
    header: 'Invoice Date',
  }),
  columnHelper.accessor(row => {
    return row.shipmentDate ? getDate(row.shipmentDate) : "";
  }, {
    id: 'shipmentDate',
    header: 'Shipment Date',
  }),
  columnHelper.accessor(row => {
    return row.receivedDate ? getDate(row.receivedDate) : "";
  }, {
    id: 'receivedDate',
    header: 'Received Date',
  }),
  {
    accessorKey: 'status',
    header: 'Shipment Status',
    enableColumnFilter: false,
    cell: ({ row }) => {
      let statusClass = '';
      switch (row.original.status) {
        case 'Received':
          statusClass = 'bg-placed';
          break;
        case 'Cancelled':
          statusClass = 'bg-cancelled';
          break;
        case 'Open':
          statusClass = 'bg-open';
          break;
        case 'Shipped':
          statusClass = 'bg-shipped';
          break;
        case 'Rejected':
          statusClass = 'bg-reject';
          break;
        // Add more cases as needed for other status values
        default:
          statusClass = '';
      }

      return <span className={`badge ${statusClass}`}>{row.original.status}</span>;
    }
  },
  {
    accessorKey: 'linkedPo',
    header: 'Linked PO #',
    // cell: ({ row }) => (
    //   // <button onClick={() => navigateCallback(row.original.id)}>
    //   //     Go to Details
    //   // </button>
    //   <div class="d-flex clays-sm justify-content-center">
    //     <button class="cir gray-bg">
    //       <span class="inner-clay color-green"></span>
    //     </button>
    //   </div>
    // )
  },
  {
    accessorKey: 'action',
    header: 'Action',
    cell: ({ row }) => (
      // <button onClick={() => navigateCallback(row.original.orderId)}>
      //     Go to Details
      // </button>
      <div class="d-flex clays-sm">
        <button class="icon-clay" onClick={() => handleAction(row.original, 'view')}>
          <span class="inner-clay color-black"><img src={eyeIcon} alt="View" /></span>
        </button>
        {row.original.isShipped === 0 && (
          <button class="icon-clay" onClick={() => handleAction(row.original, 'edit')}>
            <span class="inner-clay color-black"><img src={editIcon} alt="Edit" /></span>
          </button>
        )}
        {row.original.isShipped === 0 && (
          <button class="icon-clay" onClick={() => handleAction(row.original, 'place')}>
            <span class="inner-clay color-black"><img src={placeShipmentIcon} alt="Edit" /></span>
          </button>
        )}
        {row.original.isReceived === 1 && (
          <button class="icon-clay" onClick={() => handleAction(row.original, 'download')}>
            <span class="inner-clay color-black"><img src={downloadIcon} alt="View" /></span>
          </button>
        )}
        {/* { row.original.isRejected === 1 && (
          <button class="icon-clay" onClick={() => navigateCallback(row.original.shipmentId, 'reason')}>
          <span class="inner-clay color-black"><img src={questionMarkIcon} alt="View" /></span>
        </button>
        )} */}
        {row.original.isReceived === 0 && row.original.isRejected === 0 && row.original.isCancelled === 0 && row.original.isShipped === 1 && (
          <button class="icon-clay" onClick={() => handleAction(row.original, 'cancelShipment')}>
            <span class="inner-clay color-red"><img src={xIcon} alt="Cancel" /></span>
          </button>
        )}
        {row.original.isReceived === 0 && row.original.isRejected === 0 && row.original.isCancelled === 0 && row.original.isShipped === 0 && (
          <button class="icon-clay" onClick={() => handleAction(row.original, 'delete')}>
            <span class="inner-clay color-red"><img src={deleteIcon} alt="Delete" /></span>
          </button>
        )}
        {row.original.isCancelled === 1 && (
          <>
            <ReasonModalComponent
              // open={isReasonModalOpen}
              // onClose={() => onClose}
              // action={actionType}
              reasonData={row.original} />
          </>
        )}
        {row.original.isRejected === 1 && (
          <>
            <RejectReasonShipmentModalComponent
              // open={isReasonModalOpen}
              // onClose={() => onClose}
              // action={actionType}
              rejectReasonData={row.original} />
          </>
        )}
      </div>
    )
  },
];
// Columns of product table in Reveiw shipment
const ProductColumnDefDefaultFn = (navigateCallback, enablePagination) => [
  {
    accessorKey: 'serialNo',
    header: 'Serial No.',
    cell: ({ row }) => {
      const rowIdx = row.index;
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;

    },
  },
  {
    accessorKey: 'productName',
    header: 'Product'
  },
  {
    accessorKey: 'productDescription',
    header: 'Product Description'
  },
  {
    accessorKey: 'productQty',
    header: 'Quantity'
  },
  {
    accessorKey: 'productUom',
    header: 'Unit'
  },
  {
    accessorKey: 'blendPercentage',
    header: 'Blend % of Birla Cellulose'
  },
  {
    accessorKey: 'lotNo',
    header: 'Lot No.'
  },
  // Example of an action column, adjust based on actual functionality needed
  // {
  //   accessorKey: 'action',
  //   header: 'Actions',
  //   cell: ({ row }) => (
  //     <div class="d-flex clays-sm">
  //       <button class="icon-clay" onClick={() => navigateCallback(row.productId)}>
  //         <span class="inner-clay color-black"><img src={editIcon} alt="Edit"/></span>
  //       </button>
  //       <button class="icon-clay" onClick={() => navigateCallback(row.productId)}>
  //         <span class="inner-clay color-black"><img src={viewIcon} alt="View" /></span>
  //       </button>
  //       <button class="icon-clay">
  //         <span class="inner-clay color-red"><img src={deleteIcon} alt="Delete" /></span>
  //       </button>
  //     </div>
  //   )
  // },
];
// Columns to show the Table of added products in add product section
const ProductColumnDefFn = (navigateCallback, handleShipmentProductEdit, deleteShipmentProduct, handleAddLot) => [
  {
    accessorKey: 'serialNo',
    header: 'Serial No.',
    cell: ({ row }) => {
      const rowIdx = row.index;
      // console.log("ROWWWWWWWWW", row)
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;

    },
  },
  {
    accessorKey: 'productName',
    header: 'Product'
  },
  {
    accessorKey: 'productDescription',
    header: 'Product Description'
  },
  {
    accessorKey: 'productQty',
    header: 'Quantity'
  },
  {
    accessorKey: 'productUom',
    header: 'Unit'
  },
  {
    accessorKey: 'blendPercentage',
    header: 'Blend % of Birla Cellulose'
  },
  // Example of an action column, adjust based on actual functionality needed
  {
    accessorKey: 'action',
    header: 'Action',
    cell: ({ row }) => (
      <div class="d-flex clays-sm">
        <button class="icon-clay" onClick={() => handleShipmentProductEdit(2, 'edit', row.original.shipmentProductId)}>
          <span class="inner-clay color-black"><img src={editIcon} alt="Edit" /></span>
        </button>
        <button class="icon-clay" onClick={() => deleteShipmentProduct(row.original.shipmentProductId)}>
          <span class="inner-clay color-black"><img src={xIcon} alt="Delete" /></span>
        </button>
        <a style={{ marginTop: '7px', cursor: "pointer" }} onClick={() => handleAddLot(row.original.shipmentProductId)}>
          <span style={{ textDecorationColor: "green", textDecorationLine: "underline", color: "green", marginLeft: '7px' }} >Add Lot</span>
        </a>
        {/* <button class="icon-clay">
          <span class="inner-clay color-red"><img src={deleteIcon} alt="Delete" /></span>
        </button> */}
      </div>
    )
  },
];

// Define column structure for MainTable
const LinkedOrderColumnDefShipment = (handleLinkOrder, handleUnlinkOrder, orderId, orderNumber) => [

  {
    //   id: 'order_date', // Unique ID for the order date column
    header: 'Order Date',
    accessorKey: 'order_date',
  },
  {
    //   id: 'sender_company_name', // Unique ID for the buyer column
    header: 'Buyer',
    accessorKey: 'sender_company_name',
  },
  {
    id: 'order_number', // Unique ID for the purchase order column
    header: 'Purchase Order',
    accessorKey: 'ordernumber', // accessorKey is the "key" in the data
  },
  {
    //   id: 'action', // Unique ID for the action column
    header: 'Action',
    accessorKey: 'action',
    cell: ({ row }) => (
      // Assuming you have a function to handle the link action
      <a style={{ marginTop: '7px', cursor: "pointer" }} onClick={() => {// console.log("ROOOOOOOWWWWWWWWWW",row,"row.original.ordernumber == orderNumber",row.original.ordernumber == orderNumber);
        (row.original.orderid === orderId || row.original.ordernumber == orderNumber) ? handleUnlinkOrder(row.original) : handleLinkOrder(row.original) }}>
        <span style={{ textDecorationColor: "green", textDecorationLine: "underline", color: "green", marginLeft: '7px' }} >{row.original.orderid === orderId  || row.original.ordernumber == orderNumber? 'Unlink' : 'Link'}</span>
      </a>
      // <button onClick={() => handleLinkOrder(row.original,"link")}>Link</button>
    ),
  },
  columnHelper.accessor(row => {
    return row.is_linked ? 'Yes' : 'No';
  }, {
    id: 'linkedOrder', // Custom ID for the column
    header: 'Linked Order',
  }),
  // ... Add other columns as needed
];

// Define column structure for stock lot Table
const stockLotTableColumnDef = (handleAddStockLot) => [
  {
    accessorKey: 'serialNo',
    header: 'Serial No.',
    cell: ({ row }) => {
      const rowIdx = row.index;
      // console.log("ROWWWWWWWWW", row)
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;

    }
  },
  {
    header: 'Lot#',
    accessorKey: 'invoiceNumber',
  },
  columnHelper.accessor(row => {
    // console.log("Test row", row);
    return row.product ? row.product.productName : "";
  }, {
    id: 'product', // Unique ID 
    header: 'Product',
  }),
  columnHelper.accessor(row => {
    // console.log("Test row", row);
    return row.sellerCompany ? row.sellerCompany.companyName : "N/A";
  }, {
    id: 'supplier', // Unique ID 
    header: 'Supplier',
  }),
  {
    header: 'Quantity',
    accessorKey: 'productQty',
  },
  {
    header: 'Unit',
    accessorKey: 'productUOM',
  },
  {
    header: 'Blend % of Birla',
    accessorKey: 'blendPercentage',
  },
  {
    //   id: 'action', // Unique ID for the action column
    header: 'Action',
    accessorKey: 'action',
    cell: ({ row }) => (
      <a style={{ marginTop: '7px', cursor: "pointer" }} onClick={() => handleAddStockLot(row.original)}>
      <span style={{ textDecorationColor: "green", textDecorationLine: "underline", color: "green", marginLeft: '7px' }} >Add</span>
    </a>
    ),
  },
  // ... Add other columns as needed
];

// Define column structure for selected stock lot Table
const selectedStockLotTableColumnDef = (handleEditLotQty, handleDelete) => [
  {
    accessorKey: 'serialNo',
    header: 'Serial No.',
    cell: ({ row }) => {
      const rowIdx = row.index;
      // console.log("ROWWWWWWWWW", row)
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;

    }
  },
  {
    header: 'Supplier invoice Number',
    accessorKey: 'invoiceNumber',
  },
  {
    header: 'Product',
    accessorKey: 'stock.product.productName',
  },
  {
    header: 'Quantity',
    accessorKey: 'stock.productQty',
  },
  {
    header: 'Unit',
    accessorKey: 'stock.productUOM',
  },
  {
    header: 'Blend % of Birla',
    accessorKey: 'stock.blendPercentage',
  },
  {
    //   id: 'action', // Unique ID for the action column
    header: 'Action',
    accessorKey: 'action',
    cell: ({ row }) => (
      <div class="d-flex clays-sm">
      <a style={{ marginTop: '7px', cursor: "pointer" }} onClick={() => handleEditLotQty(row.original)}>
      <span style={{ textDecorationColor: "green", textDecorationLine: "underline", color: "green", marginLeft: '7px' }} >Edit quantity</span>
    </a>
    <button class="clays-sm icon-clay" onClick={() => handleDelete(row.original, 'delete')}>
    <span class="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
  </button>
  </div>
    ),
  },
  // ... Add other columns as needed
];

// Define column structure for Lot Details Table
const StockColumnDefFn = () => [
  {
    accessorKey: 'serialNo',
    header: 'Serial No.',
    cell: ({ row }) => {
      const rowIdx = row.index;
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;

    }
  },
  {
    header: 'Supplier invoice Number',
    accessorKey: 'invoiceNumber',
  },
  {
    header: 'Product',
    accessorKey: 'stock.product.productName',
  },
  {
    header: 'Quantity',
    accessorKey: 'stock.productQty',
  },
  {
    header: 'Unit',
    accessorKey: 'stock.productUOM',
  },
  {
    header: 'Blend % of Birla',
    accessorKey: 'stock.blendPercentage',
  },
];

export { ColumnDefShipmentInbox, ColumnDefShipmentOutbox, ProductColumnDefDefaultFn, ProductColumnDefFn, LinkedOrderColumnDefShipment, stockLotTableColumnDef, selectedStockLotTableColumnDef, StockColumnDefFn }